export default {
  filterPlaceholder: 'Nach Status filtern',
  confirmReset: {
    header: 'Status von "{filePathId}" zurücksetzen?',
    message: 'Die Logdatei bleibt erhalten und wird in der nächsten Erkennungsrunde erneut importiert.',
  },
  resetSelected: 'Auswahl zurücksetzen ({count})',
  confirmBulkReset: {
    header: 'Status von {count} Logdateien zurücksetzen?',
    message: 'Die Logdateien bleiben erhalten und werden in der nächsten Erkennungsrunde erneut importiert.',
  },
};
